import { render } from "./TagDeleteModal.vue?vue&type=template&id=75911f5e&scoped=true&ts=true"
import script from "./TagDeleteModal.vue?vue&type=script&lang=ts"
export * from "./TagDeleteModal.vue?vue&type=script&lang=ts"

import "./TagDeleteModal.vue?vue&type=style&index=0&id=75911f5e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75911f5e"]])

export default __exports__